/**
 * @generated SignedSource<<2228bd15629e56d120b2173ab2c36b24>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useFlightDuration_fragment$data = {
  readonly landingUtime: number | null;
  readonly takeoff: string | null;
  readonly takeoffUtime: number | null;
  readonly " $fragmentType": "useFlightDuration_fragment";
};
export type useFlightDuration_fragment$key = {
  readonly " $data"?: useFlightDuration_fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFlightDuration_fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useFlightDuration_fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "takeoff",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "landingUtime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "takeoffUtime",
      "storageKey": null
    }
  ],
  "type": "Flight",
  "abstractKey": null
};

(node as any).hash = "d82074da6cc7056e022bc60b7d86b84f";

export default node;
